import loadable from '@loadable/component';

export const Header = loadable(() => import('./Header/Header'));
export const Footer = loadable(() => import('./Footer/Footer'));
export * from './Body';
